import { fetchData, API_TYPE } from '@umu/umu-fetch';

let configObj: any = null;
/**
 * @description 官网顶部header、footer的配置文件，当前为写在前端代码中，后续若有配置化平台，此文件夹内的内容均应当从接口下发配置信息
 * @document 配置参考文档： https://docs.google.com/spreadsheets/d/13m_m1IdFbN6S31gNov1BZL2GrWacEoLjyp9LnJRAZVY/edit#gid=1352840756
 * @param platform
 * @param system
 * @returns
 */
export const getMenuData = async function () {
    if (configObj) {
        return configObj;
    } else {
        return await fetchData({
            type: API_TYPE.GET,
            url: '/napi/v1/home/config',
        }).then((res: any) => {
            if (res.data) {
                configObj = res.data;
            }
            return res.data;
        });
    }
};
